import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export default function LoadingState({
	title = "Loading Report",
	message = "Fetching your AEO and GEO audit data...",
}) {
	return (
		<div className="aeo-grader-report">
			<div className="loading-state">
				<motion.div
					className="loading-state__content"
					initial={{ opacity: 0, scale: 0.9 }}
					animate={{ opacity: 1, scale: 1 }}
				>
					<motion.div
						className="loading-state__spinner"
						animate={{ rotate: 360 }}
						transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
					>
						<Loader2 className="loading-state__icon" />
					</motion.div>
					<h2 className="loading-state__title">{title}</h2>
					<p className="loading-state__message">{message}</p>
				</motion.div>
			</div>
		</div>
	);
}
